// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608070401/js/" + chunkId + "." + {"44":"917f5206","225":"a3befe0e","481":"56040c60","486":"722c4de2","770":"b48420f5"}[chunkId] + ".0.25052772194240147.chunk.js";
};